import React, { useState } from "react";
import "../Styles/Home.css";
import logoMain from "../Assets/logoNH7.png";
import titleSafety from "../Assets/Safety/SafetyTitle.png";
import generalSafety from "../Assets/Safety/GeneralSafety.mp4";
import SubstanceSafety from "../Assets/Safety/SubstanceSafety.mp4";
import back from "../Assets/back.svg";
import WomenSafety from "../Assets/Safety/WomenSafety.mp4";
import posterOne from "../Assets/Safety/posterOne.png";
import posterTwo from "../Assets/Safety/posterTwo.png";
import posterThree from "../Assets/Safety/posterThree.png";
import gs from "../Assets/Safety/gs.svg";
import ss from "../Assets/Safety/ss.svg";
import ws from "../Assets/Safety/ws.svg";

const Safety = () => {
  return (
    <div>
      <div>
          <a href="/" className="fBack">
            <img src={back} className="backBtn" alt="back button"></img>
          </a>
        </div>
      <section className="height_custom">
        <div className="content_div_safety">
          <a href="/">
            <img
              src={logoMain}
              className="logoMain_pages"
              alt="nh7 Weekender logo"
            ></img>
          </a>
          <div className="safety_block">
            <img
              src={titleSafety}
              className="safety_title"
              alt="safety title"
            ></img>
            <div className="video_first">
              <video
                id="video_bg"
                playsInline="playsinline"
                loop="loop"
                style={{ width: "100%", borderRadius:"12px" }}
                poster={posterOne}
                preload={true}
                controls={true}
              >
                <source src={generalSafety} type="video/mp4"></source>
              </video>
              <img src={gs} className="titleSafetyVideo" alt="General Safety"></img>
              <video
                id="video_bg"
                playsInline="playsinline"
                loop="loop"
                style={{ width: "100%", borderRadius:"8px" }}
                preload={true}
                poster={posterTwo}
                controls={true}
              >
                <source src={SubstanceSafety} type="video/mp4"></source>
              </video>
              <img src={ss} className="titleSafetyVideo" alt="Substance Safety"></img>
              <video
                id="video_bg"
                playsInline="playsinline"
                loop="loop"
                style={{ width: "100%", borderRadius:"8px" }}
                preload={true}
                poster={posterThree}
                controls={true}
              >
                <source src={WomenSafety} type="video/mp4"></source>
              </video>
              <img src={ws} className="titleSafetyVideo" alt="Women Safety"></img>
            </div>
            
          </div>
        </div>
      </section>
    </div>
  );
};

export default Safety;
